import {Component, OnInit, OnDestroy, EventEmitter, Output} from '@angular/core';
import {TimeCardsStore} from '../../../data/time-cards.store';
import {TimeCardsQuery} from '../../../data/time-cards.query';
import * as moment from 'moment';
import {TimeCardService} from '../../../data/time-card.service';
import {TimeCard} from '../../../data/time-card';
import {MatSnackBarRef, SimpleSnackBar, MatSnackBar} from '@angular/material/snack-bar';
import {Subscription, interval, Subject} from 'rxjs';
import {CustomCoordinates} from '../../../data/custom-coordinates';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {takeUntil} from 'rxjs/operators';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';

@Component({
  selector: 'app-break',
  templateUrl: './break.component.html',
  styleUrls: ['./break.component.scss']
})
@RxJSUnsubscribe
export class BreakComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  lastTimeCard: TimeCard;

  lastCardWithJob: TimeCard;

  breakType = ''

  breakName = ''

  timerString = '';
  breakTimeString$ = this.timeCardsQuery.breakTimeString$;

  intervalSub: Subscription;

  duration: number;

  userCoordinates: CustomCoordinates;

  activeSnackBar: MatSnackBarRef<SimpleSnackBar>

  @Output()
  showProjects = new EventEmitter<void>();

  constructor(
    private snackBar: MatSnackBar,
    private timeCardService: TimeCardService,
    private timeCardsStore: TimeCardsStore,
    private timeCardsQuery: TimeCardsQuery,
  ) {
  }

  ngOnInit() {
    this.timeCardsQuery.lastTimeCard
      .pipe(takeUntil(this.getUnsubFromAllSubs()))
      .subscribe(card => {
        this.lastTimeCard = card

        this.timer();

      })

    this.getGeolocation();
    this.timeCardsQuery.breakType$
      .pipe(takeUntil(this.getUnsubFromAllSubs()))
      .subscribe(type => {
        if (type === 'PAID_BREAK') {
          this.breakType = 'PAID';
          this.breakName = 'Rest';
        }
        if (type === 'UNPAID_BREAK') {
          this.breakType = 'UNPAID'
          this.breakName = 'Lunch';
        }
      })

    this.timeCardsQuery.todayCards
      .pipe(takeUntil(this.getUnsubFromAllSubs()))
      .subscribe(cards => {
        this.lastCardWithJob = cards.find(card => !!card.job);
      })


  }

  endBreak() {
    if (!this.userCoordinates) {
      this.openSnackBar('You should share your location or use shop Wi-Fi')

      this.getGeolocation();

      return;
    }

    this.timeCardService.finishBreak(this.userCoordinates.latitude, this.userCoordinates.longitude)
      .subscribe(() => {
        this.showProjects.emit();
      })
  }

  timer() {
    // if(!this.intervalSub){}

    this.intervalSub = interval(1000)
      .pipe(
        takeUntil(this.getUnsubFromAllSubs())
      ).subscribe(() => {
        if (this.lastTimeCard) {
          this.timeCardsStore.updateBreakTime(moment().diff(this.lastTimeCard.startTime, 'seconds'));
        }
      })
  }

  getGeolocation() {
    this.timeCardService.isUserInShop()
      .pipe(takeUntil(this.getUnsubFromAllSubs()))
      .subscribe(coords => {
        if (coords.latitude !== 0 || coords.longitude !== 0) {
          this.userCoordinates = coords
        } else {

          navigator.geolocation.getCurrentPosition(
            position => {
              this.userCoordinates = position.coords
            },
            error => {
              if (error.code === error.PERMISSION_DENIED) {
                this.openSnackBar('Geolocation should be allowed')
              } else {
                this.openSnackBar('Could not determine your geolocation')
              }
            });
        }
      })
  }

  openSnackBar(message: string) {
    if (this.activeSnackBar) {
      this.activeSnackBar.dismiss();
    }

    this.activeSnackBar = this.snackBar.open(message, '', {
      duration: 5000,
      panelClass: 'break-snackbar',
      verticalPosition: 'top',
    });
  }

  ngOnDestroy() {
    this.intervalSub.unsubscribe();
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }


}
